import { render, staticRenderFns } from "./UpdateEmailConfirm.vue?vue&type=template&id=0f08f841"
import script from "./UpdateEmailConfirm.vue?vue&type=script&lang=ts"
export * from "./UpdateEmailConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports